import { Box, Button, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import moment from "moment";
import axios from "axios";
import { useEffect, useState } from "react";
import { loadEventAction } from "redux/reducers/event/index";
import { useDispatch, useSelector } from "react-redux";
import { eventDateFormat, renderNoti } from "assets/js/common";
import InnerHTML from "dangerously-set-html-content";
import Comment from "../comment";
import FavoriteItem from "./favorite";

const useStyles = makeStyles((theme) => ({
  announcemetDetail: {
    "& .eventImg": {
      "& img": {
        width: "100%",
      },
    },
    "& .info": {
      padding: "40px 30px",
      borderBottom: "1px solid #eee",
      "& table": {
        fontSize: rem(14),
        borderCollapse: "0",
        borderSpacing: "0",
        "& tr": {
          "& th": {
            display: "flex",
            width: rem(85),
            textAlign: "left",
            fontWeight: 800,
          },
          "& td": {
            wordBreak: "keep-all",
            lineHeight: rem(22),
          },
          "& + tr th, & + tr td": {
            paddingTop: rem(20),
          },
        },
      },
    },
    "& .bottom-wrap": {
      display: "flex",
      flexDirection: "column",
      "& button": {
        marginTop: `${rem(40)}`,
        "&.btnYellow": {
          backgroundColor: "#FFBB53",
        },
      },
    },
  },
}));

export default function EventDetailDefault(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { evtForm, event, loading } = useSelector((state) => state.event);
  const [detailData, setDetailData] = useState([]);
  const { selectedSeq, mode } = props;

  if (!event) return <></>;

  return (
    <div className={classes.announcemetDetail}>
      <Box className="box-type-7">
        <div className="tit">{event.ttl}</div>
        <div className="sub-tit">{event.desc}</div>

        <div className="board-info">
          <span>{eventDateFormat(event.expsStrtYmd, event.expsEndYmd)}</span>
          <span>이벤트</span>
        </div>
      </Box>
      <Box pb={2}>
        <img src={event.progImgUrl} />
      </Box>

      <InnerHTML html={event.topCont} />

      <Box className="box-type-1">
        <Box className="notice">
          <p className="title">
            <i className="ico-noti" />
            유의사항
          </p>
          <ul className="list list-dot color-info font-14">
            {renderNoti(event.noti).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </Box>
      </Box>

      <Divider />

      <Box className="box-type-1">
        <FavoriteItem mode={"event"} item={event} />
      </Box>

      {(event.evtTp == 2 || event.evtTp == 7) && <Comment evSeq={event.seq} />}
    </div>
  );
}
